export default {
  toasts: {
    load_error: 'Facturen konden niet worden geladen.',
    action_error: 'De actie is mislukt — probeer het opnieuw.',
    finalized: 'Factuur afgerond.',
    marked_paid: 'Factuur gemarkeerd als betaald.',
  },
  filters: {
    status: 'Filteren op status',
  },
  volume_discount_badge: 'Volumekorting toegepast ({{licenses}} licenties, {{percent}}%)',
  columns: {
    description: 'Factuur',
    status: 'Status',
    total: 'Totaal',
    paid_at: 'Betaald op',
  },
  statuses: {
    pending: 'In behandeling',
    processing: 'Verwerking',
    paid: 'Betaald',
    failed: 'Mislukt',
    refunded: 'Terugbetaald',
    partially_refunded: 'Gedeeltelijk terugbetaald',
  },
  companies: {
    partner_level: 'Aanpassingen op partnerniveau',
    columns: {
      company: 'Restaurant',
      buckets: 'Posities',
      amount: 'Bedrag',
    },
  },
  buckets: {
    license_fees: 'Licentiekosten',
    service_fees: 'Servicekosten',
    processing_fees: 'Verwerkingskosten',
    delivery_fees: 'Bezorgkosten',
    gift_card_fees: 'Cadeaukaartenkosten',
    adjustments: 'Correcties',
  },
  entries: {
    count: '{{count}} vermeldingen',
    columns: {
      description: 'Vermelding',
      occurred_at: 'Datum',
      amount: 'Bedrag',
    },
  },
  incl_tax: 'incl. {{amount}} btw',
  actions: {
    open_invoice_pdf: 'Factuur downloaden (PDF)',
    open_hosted: 'Factuur openen in Stripe',
    export_csv: 'CSV exporteren',
    finalize: 'Afronden in Stripe',
    mark_paid: 'Markeren als betaald',
  },
  finalize: {
    title: 'Deze factuur afronden in Stripe?',
    description:
      'Afronden start de inning: met een opgeslagen betaalmethode wordt het bedrag automatisch afgeschreven, anders ontvangt de partner de gehoste factuur.',
    confirm: 'Afronden',
  },
  mark_paid: {
    pushed_note:
      'Deze factuur staat al in Stripe — het concept wordt verwijderd (of een afgeronde factuur als handmatig betaald gemarkeerd) zodat Stripe stopt met innen.',
    title: 'Deze factuur als betaald markeren?',
    description:
      'Registreert een handmatige (offline) betaling van {{amount}}. Gebruik dit voor bankoverschrijvingen die buiten Stripe worden ontvangen.',
    confirm: 'Markeren als betaald',
  },
  settlement_badge: {
    paid: 'Omzetaandeel uitbetaald: {{amount}}',
    other: 'Omzetaandeel-uitbetaling {{amount}} · {{status}}',
  },
  settlements: {
    title: 'Omzetaandeel-uitbetalingen',
    retry: 'Opnieuw proberen',
    toasts: {
      load_error: 'Kan de uitbetalingen niet laden.',
      retry_error: 'De nieuwe poging is mislukt — probeer het opnieuw.',
      retry_paid: 'Omzetaandeel uitbetaald.',
      retry_attempted: 'Nieuwe poging uitgevoerd — de uitbetaling is nog niet voltooid, controleer de status.',
    },
    columns: {
      period: 'Periode',
      amount: 'Bedrag',
      status: 'Status',
      transfer: 'Overboeking',
      paid_at: 'Betaald op',
      payout: 'Uitbetaling',
    },
    payout: {
      direct: '{{amount}}, geen conversie',
      direct_tooltip:
        'Verschuldigd {{owed}}, omgerekend tegen 1 {{payout_currency}} = {{ledger_rate}} {{billing_currency}} en verzonden zoals het is: geen Stripe-conversie, geen kosten.',
      converted: 'Verzonden {{sent}} → aangekomen {{arrived}}',
      expected: 'Verzonden {{sent}} → verwacht {{arrived}}',
      fee: 'Stripe-conversiekosten {{amount}}',
      net: 'netto {{amount}}',
      pending_details: 'Kosten en netto verschijnen zodra Stripe de overboeking afwikkelt.',
      tooltip:
        'Verschuldigd {{owed}}. Omgerekend tegen 1 {{payout_currency}} = {{ledger_rate}} {{billing_currency}}, verzonden vanuit het platformsaldo in {{source_currency}}, en door Stripe omgerekend tegen 1 {{source_currency}} = {{stripe_rate}} {{payout_currency}}. Stripe trekt {{fee_rate}}% af bij aankomst.',
    },
    statuses: {
      pending: 'In behandeling',
      held: 'Vastgehouden',
      processing: 'Verwerking',
      paid: 'Uitbetaald',
      failed: 'Mislukt',
      reversed: 'Teruggeboekt',
    },
    hold_reasons: {
      kyc_incomplete: 'De partner heeft de verificatie van het uitbetalingsaccount nog niet voltooid.',
      transfers_inactive: 'Het uitbetalingsaccount kan nog geen overboekingen ontvangen.',
      insufficient_platform_balance: 'Het platformsaldo dekt deze uitbetaling momenteel niet.',
      manual_hold: 'Handmatig vastgehouden.',
      missing_fx_rate:
        'Er is nog geen wisselkoers opgeslagen voor de uitbetalingsvaluta. Dit wordt automatisch opnieuw geprobeerd.',
      unsupported_payout_currency:
        'Stripe kan dit niet uitbetalen op de valuta van de uitbetalingsrekening vanuit het platformsaldo.',
      amount_too_small: 'Het verschuldigde bedrag ligt onder de minimale overschrijving van Stripe voor deze valuta.',
    },
  },
};
